import { EuiPage } from "@elastic/eui";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";

import client from "../api/Client";
import LoginForm from "../components/LoginForm";
import { ShopContext } from "../utils/Shop";

const Login = ({ alert }) => {
    const [, setErrorMessage] = useState("");
    // const [loading, setLoading] = useState(false);
    // const [email, setEmail] = useState("");
    // const [isLogin, setIsLogin] = useState(true);

    const context = useContext(ShopContext);

    useEffect(() => {
        console.log("LoginPage mounted");
    }, []);

    // const handleShowResetPassword = (event) => {
    //     event.preventDefault();
    //     console.log("Switching to register form");
    //     setIsLogin(false);
    // };

    const handleLogin = (token) => {
        console.log(`Handle Login called on page level with token: ${token}`);
        client
            .get(`/v1/users/me`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                const data = res.data;
                const userData = {
                    id: data.id,
                    email: data.email,
                    username: data.username,
                    is_superuser: data.is_superuser,
                    token: token,
                    shop_groups: data.shop_groups,
                    roles: data.roles ?? [],
                };
                const appState = {
                    isLoggedIn: true,
                    profile: userData,
                };
                localStorage["appState"] = JSON.stringify(appState);
                // setEmail(data.email);

                console.log("User data fetched: ", data);

                //TODO Fixed when shops_users is implemented
                if (data.email.startsWith("maryjane@")) {
                    context.setShopName("Mary Jane");
                    context.setShopId("bbc0cfa7-e230-4338-817a-55190debdac0");
                    context.setIsUsingMultiScreen(
                        data.shop_groups
                            .find((group) =>
                                group.shops.some((shop) => shop.id === "bbc0cfa7-e230-4338-817a-55190debdac0")
                            )
                            .shops.find((shop) => shop.id === "bbc0cfa7-e230-4338-817a-55190debdac0")
                            .is_using_multiscreen
                    );
                } else if (data.email.startsWith("easygoing@")) {
                    context.setShopName("Easy Going");
                    context.setShopId("ddd70853-5e9d-45ff-82b3-24c9d81d4e32");
                    context.setIsUsingMultiScreen(
                        data.shop_groups
                            .find((group) =>
                                group.shops.some((shop) => shop.id === "ddd70853-5e9d-45ff-82b3-24c9d81d4e32")
                            )
                            .shops.find((shop) => shop.id === "ddd70853-5e9d-45ff-82b3-24c9d81d4e32")
                            .is_using_multiscreen
                    );
                } else if (data.email.startsWith("missouri@")) {
                    context.setShopName("Missouri");
                    context.setShopId("a08a13e2-a31b-4b6d-b2b4-0491cb3d2227");
                    context.setIsUsingMultiScreen(
                        data.shop_groups
                            .find((group) =>
                                group.shops.some((shop) => shop.id === "a08a13e2-a31b-4b6d-b2b4-0491cb3d2227")
                            )
                            .shops.find((shop) => shop.id === "a08a13e2-a31b-4b6d-b2b4-0491cb3d2227")
                            .is_using_multiscreen
                    );
                } else if (data.shop_groups.length > 0) {
                    const initialShop = data.shop_groups[0].shops[0];
                    context.setShopName(initialShop.name);
                    context.setShopId(initialShop.id);
                    context.setIsUsingMultiScreen(initialShop.is_using_multiscreen);
                }
                window.location.href = "/";
            })
            .catch((error) => {
                const data = error.response;
                if (data.status === 401) {
                    setErrorMessage(`Token based user profile fetch resulted in error: ${data.statusText}`);
                } else {
                    setErrorMessage(
                        `Token based user profile fetch resulted in error ${data.status}: ${data.statusText}`
                    );
                }
            });
    };

    // const handleReset = () => {
    //     console.log(`Handle Reset called on page level with email: ${email}`);
    //     setLoading(true);
    //
    //     const payload = { email };
    //
    //     client
    //         .post("/reset", payload)
    //         .then(() => {
    //             alert.show(`Password reset handled OK`, { type: "success" });
    //             setLoading(false);
    //             setIsLogin(true);
    //             setEmail("");
    //         })
    //         .catch((res) => {
    //             setLoading(false);
    //             setEmail("");
    //             const message = res.response.data.response.errors.email[0];
    //             if (message === "Specified user does not exist") {
    //                 alert.show(`Pass reset handled OK, check your inbox.`, { type: "success" });
    //                 setIsLogin(true);
    //             } else {
    //                 alert.show(message, { type: "error" });
    //             }
    //         });
    // };

    return (
        <EuiPage>
            <LoginForm handleLogin={handleLogin} />
        </EuiPage>
    );
};

Login.propTypes = {
    isLogin: PropTypes.bool,
    alert: PropTypes.object.isRequired,
};

Login.defaultProps = {
    isLogin: true,
};

export default Login;
